module.exports = __webpack_public_path__ + "static/img/63rd-annual-hematacon-thumb.287f792d.jpg";